import { globalOptions } from 'SRC/core/constants'
import config from 'SRC/config/config.json'
import { fetchPromoVehicleParts } from 'SRC/modules/vehicleParts/list/actions'
import { AdsListApi } from '../../api'
import { setAds } from '../setAds'
import { setLoading } from '../setLoading'
import { setPaidAds } from '../setPaidAds'
import { setPaginationParams } from '../../../pagination/actions'

export const fetchAds = (requestParams, paginationParams = {}, currentAds = []) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true))
      const api = new AdsListApi()

      if (!requestParams.status) requestParams.limit = globalOptions.allProfileAdsLimit
      const {paidAds, freeAds, paidCount, freeCount} = await api.getAds(requestParams)
      let newAds = [...paidAds, ...freeAds]

      if (requestParams.fetchPromoVehicleParts) {
        await dispatch(fetchPromoVehicleParts({ page: requestParams.page, limit: 6, locale: requestParams.locale || 'ME' }))

        const promoVehicleParts = getState().vehicleParts.list.promoProducts

        if (promoVehicleParts && promoVehicleParts.length > 0 &&requestParams.type === 'paid') {
          const adsWithPromoProducts = []
          let promoIndex = 0

          // for (let i = 0; i < newAds.length; i++) {
          //   adsWithPromoProducts.push(newAds[i])

          //   if ((i + 1) % 6 === 0 && promoIndex < promoVehicleParts.length) {
          //     adsWithPromoProducts.push({
          //       ...promoVehicleParts[promoIndex],
          //       isVehiclePart: true
          //     })
          //     promoIndex++
          //   }
          // }

          const chunkSize = 6
          for (let chunkStart = 0; chunkStart < newAds.length; chunkStart += chunkSize) {
            const chunkEnd = Math.min(chunkStart + chunkSize, newAds.length)
            const chunkAds = newAds.slice(chunkStart, chunkEnd)
            
            // Random position within this chunk (0 to chunk length)
            const randomPosition = Math.floor(Math.random() * (chunkAds.length + 1))
            
            // Add ads before the random position
            for (let i = 0; i < randomPosition; i++) {
              adsWithPromoProducts.push(chunkAds[i])
            }
            
            // Insert promo vehicle part at random position if available
            if (promoIndex < promoVehicleParts.length) {
              adsWithPromoProducts.push({
                ...promoVehicleParts[promoIndex],
                isVehiclePart: true
              })
              promoIndex++
            }
            
            // Add remaining ads after the random position
            for (let i = randomPosition; i < chunkAds.length; i++) {
              adsWithPromoProducts.push(chunkAds[i])
            }
          }

          newAds = adsWithPromoProducts
        }
      }

      const isMobileDevice = getState().common.isMobileDevice

      // Insert banner at random position if exists
      if (config.banners.adsList && config.banners.adsList.betweenAdsMobile && isMobileDevice) {
        if (newAds.length) {
          newAds.push({
            slotId: `div-gpt-ad-1681814473496-${Math.floor((Math.random() * 10000) + 1)}`,
            key: `banner-${Math.floor((Math.random() * 10000) + 1)}`,
            banner: true
          })
        }
      }

      const ads = currentAds.concat([...newAds])
      const totalCount = paidCount + freeCount

      dispatch(setAds(ads))
      dispatch(setPaidAds(paidAds.filter(ad => !ad.isVehiclePart && !ad.banner).map(ad => ad.id)))

      const pagination = {
        ...paginationParams,
        paidCount,
        freeCount,
        totalCount,
        currentPage: requestParams.incrementCurrentPage ? paginationParams.currentPage + 1 : paginationParams.currentPage
      }

      dispatch(setPaginationParams(pagination))
      dispatch(setLoading(false))
    } catch (e) {
      dispatch(setAds(currentAds))
      dispatch(setLoading(false))
    }
  }
}
